import { render } from "./EstimateDetailAfter.vue?vue&type=template&id=2614882a"
import script from "./EstimateDetailAfter.vue?vue&type=script&lang=js"
export * from "./EstimateDetailAfter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/EstimateDetailAfter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2614882a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2614882a', __exports__)) {
    api.reload('2614882a', __exports__)
  }
  
  module.hot.accept("./EstimateDetailAfter.vue?vue&type=template&id=2614882a", () => {
    api.rerender('2614882a', render)
  })

}


export default __exports__